import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/react'
import {forwardRef} from 'react'

import {IconChevronDown} from '@sdox/icons'
import {twMerge} from '@sdox/utils'
import {scrollToElementOnClick} from '@sdox/utils/dom'

import {Button} from '../Button/Button'

import type {ClassNameValue} from 'tailwind-merge'
import type {TocItem} from './TableOfContents'

export interface TableOfContentsDropwdownProps {
  items: TocItem[]
  className?: ClassNameValue
}

interface TocDropdownItemProps extends TocItem {
  onClick: () => void
}

export const Item = forwardRef<HTMLAnchorElement, TocDropdownItemProps>((props, ref) => {
  const {anchorId, name, onClick: onClickProp} = props
  const onClick = scrollToElementOnClick({element: anchorId, preventEvent: true, callback: onClickProp})

  return (
    <a
      ref={ref}
      className={'min-w-64 cursor-pointer px-spacing-24 py-spacing-8 ui-active:bg-surface-tertiary'}
      href={`#${anchorId}`}
      onClick={onClick}
    >
      <span className={'line-clamp-2'}>
        {name}
      </span>
    </a>
  )
})

export const TableOfContentsDropdown = (props: TableOfContentsDropwdownProps) => {
  const {items, className} = props

  return (
    <Menu
      as={'div'}
      className={twMerge('relative', className)}
    >
      <MenuButton
        as={Button}
        variant={'flat'}
        trailing={<IconChevronDown />}
      >
        Inhaltsverzeichnis
      </MenuButton>
      <MenuItems
        className={twMerge(
          'absolute z-10 grid max-h-[70vh] overflow-y-auto border-t-2 bg-surface-secondary',
          'focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-blue-500',
        )}
      >
        {items.map((item) => (
          <MenuItem key={item.anchorId}>
            {({close}) => (
              <Item
                onClick={close}
                {...item}
              />
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}
